import { useContext } from "react";

import { userDataContext } from "../contexts/UserDataContext";

export function useUserDataContext() {
  return useContext(userDataContext);
}
